import { render } from "./3d.vue?vue&type=template&id=2e0cb790&scoped=true"
import script from "./3d.vue?vue&type=script&lang=js"
export * from "./3d.vue?vue&type=script&lang=js"

import "./3d.vue?vue&type=style&index=0&id=2e0cb790&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0cb790"]])

export default __exports__